











































import { Component, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import UpdateJobWorkerRejectedRequest from '@/models/JobWorkers/UpdateJobWorkerStatusRejectedRequest';
import ListUtils from '@/lib/listUtils';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';

@Component({
    name: 'JobWorkerSetStatusRejected'
})
export default class extends GiganautVueDialog {
 
  @Prop({required: true})
  jobWorker: JobWorkerDto;
    
  request: UpdateJobWorkerRejectedRequest = new UpdateJobWorkerRejectedRequest();

  get job() {
    return JobDetailsModule.currentJob;
  }

  @Watch("dialog")
  async dialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new UpdateJobWorkerRejectedRequest();
      this.request.jobWorkerId = this.jobWorker.id; 
      this.request.updatedAt = this.jobWorker.updatedAt;
    } 
    this.$emit("closeMenu");
  }

  get rejectedReasons() {
    return ListUtils.jobWorkerRejectedReasons();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await JobDetailsModule.updateJobWorkerStatusRejected(this.request);
    this.dialog = false;
  }
}
